import { render, staticRenderFns } from "./CSlider.vue?vue&type=template&id=ab2b719c&scoped=true"
import script from "./CSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSlider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CSlider.vue?vue&type=style&index=0&id=ab2b719c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2b719c",
  null
  
)

export default component.exports